var mobileHover;

(function($) {

    mobileHover = function() {

        document.addEventListener("touchstart", function(){}, true);

        // if main menu item has a submenu, prevent it from following the href,
        // open the submenu instead
        $(".ws-navbar-collapse .collapse-submenu").on("touchstart", function() {
            // $(".ws-navbar-collapse .collapse-submenu a")
            $(this).find('a').first().on("click", function(e) {
                e.preventDefault();
            });
        });

    }


})(jQuery);